<template>
  <div>
    <h1 class="headline font-weight-medium grey--text my-2">Login</h1>

    <v-form class="px-12" ref="form" lazy-validation>
      <v-text-field
        v-model="email"
        :rules="emailRules"
        type="email"
        label="E-mail"
        outlined
      ></v-text-field>
      <v-text-field
        v-model="password"
        :rules="passwordRules"
        label="Senha"
        outlined
        :append-icon="show_password ? 'visibility' : 'visibility_off'"
        :type="show_password ? 'text' : 'password'"
        @click:append="show_password = !show_password"
      ></v-text-field>
      <v-container>
        <v-layout row wrap>
          <a @click="forgotPassword">Esqueceu a senha?</a>
          <v-spacer></v-spacer>
          <v-btn
            class="body-2 white--text"
            color="primary"
            width="120"
            height="45"
            depressed
            :loading="loader"
            @click="signIn"
          >Login</v-btn>
        </v-layout>
      </v-container>
    </v-form>
  </div>
</template>

<script>
export default {
  name:"Authentication",
  data:()=>({
    email:"",
    password: "",
    show_password: false,
    emailRules:[
      v=> !!v || 'Necessário preencher o E-mail!',
      v=> /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/.test(v) || 'E-mail inválido!'
    ],
    passwordRules:[
      v=> !!v || 'Necessário preencher a senha!'
    ]
  }),
  created() {
  },
  mounted() {
    window.addEventListener('keydown', this.handleEnter)
  },
  destroyed() {
    window.removeEventListener('keydown', this.handleEnter)
  },
  computed:{
    loader() {
      return this.$store.getters.loader;
    },
  },
  methods:{
    forgotPassword() {
      this.$router.push('esqueceusenha')
    },
    handleEnter(e) {
      if (e.key === 'Enter') {
        this.signIn()
      }
    },
    signIn() {
      if(this.$refs.form.validate()){
        this.$store.dispatch("signUserIn", {
          email: this.email,
          password: this.password
        });
      }
    },
  }
};
</script>

<style>
</style>
